import React, { Component } from 'react'
import Formsy from 'formsy-react'
import { Modal } from 'antd'
import CustomInput from '../../CustomInput'
import css from './index.scss'

export default class DriverContactModal extends Component {
  state = {
    phone: '',
    name: '',
    saveEnabled: false,
  }
  handleSave = () => {
    this.props.addDriverContact({
      name: this.state.name,
      phone: this.state.phone,
      formattedValue: this.state.formattedValue,
    })
    this.setState({
      phone: '',
      name: '',
      saveEnabled: false,
    })
  }
  render() {
    return (
      <Modal
        title="Novo contato do motorista"
        visible={this.props.showModal}
        onCancel={this.props.hideContactModal}
        okButtonProps={{ disabled: !this.state.saveEnabled, htmlType: 'submit' }}
        onOk={this.handleSave}
        okText="Salvar"
        cancelText="Cancelar"
      >
        <Formsy
          onValid={() => {
            this.setState({
              saveEnabled: true,
            })
          }}
          onInvalid={() => {
            this.setState({
              saveEnabled: false,
            })
          }}
        >
          <div className={css.row} style={{ alignItens: 'center' }}>
            <CustomInput
              label="Nome"
              name="name"
              placeholder="Nome"
              inputStyle={{ width: 240 }}
              onChange={e => this.setState({ name: e.target.value })}
              value={this.state.name}
              required
            />
            <CustomInput
              label="Telefone"
              name="phone"
              mask="phone"
              placeholder="Telefone"
              inputStyle={{ width: 180 }}
              style={{ marginLeft: 16 }}
              onValueChange={(value, formattedValue) =>
                this.setState({ phone: value, formattedValue })}
              value={this.state.phone}
              validations={{ minLength: 10, maxLength: 11 }}
              validationErrors={{
                minLength: 'Telefone inválido.',
                maxLength: 'Telefone inválido.',
              }}
              required
            />
          </div>
        </Formsy>
      </Modal>
    )
  }
}
